export const manufacturingSelection = {
  continuousDyeing: 'Kontinü boyama',
  exhaustDyeing: 'Çektirme boyama',
  laundry: 'Yıkama',
  leather: 'Deri işleme',
  overallPrinting: 'Genel baskı',
  other: 'Kuru işlemler',
  positionalPrinting: 'Parça baskı'
};
